export interface UmpireOttEventTranscodingStatus {
  eta: number;
  finished_at: string;
  progress: number;
  queued_at: string;
  running_at: string;
  status: UmpireOttEventTranscodingState;
}

export enum UmpireOttEventTranscodingState {
  Created = 'CREATED',
  Queued = 'QUEUED',
  Running = 'RUNNING',
  Finished = 'FINISHED',
  Error = 'ERROR',
  Canceled = 'CANCELED',
  TransferError = 'TRANSFER_ERROR',
}
